/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2024 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../../core/IceEntity';

export class condition extends IceEntity {
  condition_key: string = "";
  condition_code_category: string = "";
  condition_applies: string = "";
  condition_code: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;

  constructor() {
    super();
  }

  gettablename(): string {
    return "CONDITION";
  }
}


